<template>
  <div class="contaier">
    <div class="top-nvb_box">
      <div class="top-nvb flex flex-col sm:flex-row sm:justify-center items-center pt-[15px] pb-[8px] sm:py-[12px]">
        <div class="logo-box">
          <img alt="" class="img" src="./assets/img/logo.png" />
        </div>
        <h1 class="mt-2 sm:mt-0 sm:ml-[16px] text-[1.4rem] sm:text-[1.5rem] md:text-[1.6rem] font-bold">
          尊貴客戶特享租賃計劃
        </h1>

        <!-- <h1 class=" text-center pt-[10px] text-[1.5rem] md:text-[1.6rem] font-bold">iCAUR 尊貴客戶特享租賃計劃</h1> -->
        <!-- <span class="lang" @click="changeLanguage($i18n.locale)">{{
          $t("home.lang")
          }}</span> -->
      </div>
    </div>
    <div class="top-banner mt-[87px] sm:mt-[61px] relative">
      <div
        class="absolute top-[3rem] pr-[1rem] lg:top-[10%] left-[5%] lg:left-[7%] xl:left-[10%] text-[1.4rem] lg:text-[1.6rem] xl:text-[1.8rem] font-bold"
      >
        <!-- <p class="text-[1.6rem] lg:text-[1.8rem] xl:text-[2rem] mb-2">等待新車交付期間，想親身試駕心儀車款？</p> -->
        <p>iCAUR 現為已訂車客戶提供租車優惠，讓您輕鬆試駕。</p>
      </div>
      <!-- <img
        alt=""
        src="./assets/img/banner1.jpg"
        class="img lg:aspect-7/3 md:aspect-6/3 sm:aspect-3/3 aspect-4/5" /> -->
      <picture class="picture" style="">
        <source srcset="./assets/img/icaur_car3.jpg" media="(max-width: 575px)" />
        <source srcset="./assets/img/icaur_car2.jpg" media="(max-width: 800px)" />
        <source srcset="./assets/img/icaur_car1.jpg" />
        <img src="./assets/img/icaur_car3.jpg" loading="lazy" alt="" />
      </picture>
    </div>
    <div class="max-w-[1200px] w-[92%] m-auto relative">
      <div
        class="w-[22rem] sm:w-[28.3rem] h-[6rem] sm:h-[7rem] text-[1.7rem] sm:text-[2.2rem] absolute top-[-10rem] sm:top-[-12.5rem] right-[0] shadow-lg shadow-[rgba(0,0,0,0.5)] bg-[#f48e30] skew-y-[-3deg] text-center font-bold flex items-center justify-center"
      >
        平日：$90/3小時
        <br />
        周末及公衆假期：$35/小時
      </div>
    </div>
    <div
      class="w-[100%] bg-cover bg-top"
      style="background-image: url('https://www.kamlung.net/images/icaur/other/icaur_bg.jpg')"
    >
      <div class="max-w-[1200px] w-[92%] m-auto pb-[50px] md:pb-[40px] text-left text-[#b6b6b6]">
        <div class="lg:text-[36px] text-[30px] md:pt-[80px] pt-[60px] pb-[40px] text-[#f48e30]">租車流程 簡單快捷</div>
        <ul class="px-5 py-5 text-[16px] flex flex-row flex-wrap [counter-reset:step]">
          <li class="mb-6 px-2 w-[94%] md:w-[88%] lg:w-[70%] text-left">
            <div
              class="flex items-center mb-3 text-[20px] lg:text-[22px] text-[#fff] [counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#fff] before:ml-[-22px]"
            >
              預約租車
              <a
                href="#section1"
                class="h-[20px] md:h-[22px] flex items-center not-italic text-[11px] md:text-[12px] ml-[10px] px-1 cursor-pointer bg-no-repeat text-[#000]"
                style="
                  background-size: 100%;
                  background-image: url(data:image/png;base64,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);
                "
              >
                即刻預訂
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.2"
                  stroke="currentColor"
                  class="size-4"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                </svg>
              </a>
            </div>
            <div class="leading-7">客戶於網上選擇心儀車型、租車日期及時間，並提交表格。</div>
          </li>
          <li class="mb-6 px-2 w-[94%] md:w-[88%] lg:w-[70%] text-left">
            <div
              class="mb-3 text-[20px] lg:text-[22px] text-[#fff] [counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#fff] before:ml-[-28px]"
            >
              提取車輛
            </div>
            <div class="leading-7">
              租車當日，請提前15分鐘到達 iCAUR 九龍灣陳列室辦理手續。
              <br />
              提取車輛時，客戶須出示有效身份證、駕駛證及訂車合同副本，並於陳列室以轉數快(FPS)支付相關款項。
            </div>
            <div class="leading-7 text-[#f48e30]">取車地點：九龍灣宏冠道6號鴻力中心B8-9地下</div>
          </li>
          <li class="mb-6 px-2 w-[94%] md:w-[88%] lg:w-[70%] text-left">
            <div
              class="mb-3 text-[20px] lg:text-[22px] text-[#fff] [counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#fff] before:ml-[-28px]"
            >
              使用租車
            </div>
            <div class="leading-7">客戶可安心駕駛，我們的車輛均定期保養，狀態良好。客戶可根據需要自由安排行程。</div>
          </li>
          <li class="mb-6 px-2 w-[94%] md:w-[88%] lg:w-[70%] text-left">
            <div
              class="mb-3 text-[20px] lg:text-[22px] text-[#fff] [counter-increment:step] before:content-[''counter(step)'.'] before:mr-2 before:font-bold before:text-[#fff] before:ml-[-28px]"
            >
              歸還車輛
            </div>
            <div class="leading-7">
              請於租賃期滿前將車輛歸還至 iCAUR 九龍灣陳列室。
              <br />
              逾時歸還將收取附加費用，詳情請參閱租賃條款及細則。
              <br />
              職員檢查車輛狀況無誤後，即完成租賃程序。
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div @click="testFn">test</div> -->
    <div id="section1" class="w-full h-1"></div>
    <form-page ref="formPageRef"></form-page>
    <footer-page></footer-page>
  </div>
</template>

<script>
// import { carouselList, textList, imgsrc } from '@/assets/js/static.js'
import FormPage from '@/components/FormPage.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'HomeView',
  components: {
    FormPage,
    FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      speak: '中文',
    }
  },
  computed: {},
  mounted() {
    //可能是router没准备好，用this.$router.onReady解决
    // this.$router.onReady(() => {
    //   let query = this.$route.query;
    //   console.log("onReady :>>query ", query);n
    // });
    // console.log("(this.$i18n.locale :>>11 ", this.$i18n.locale);
    // console.log("this.$route.query.lang :>> ", this.$route.query);
    // if (this.$route?.query?.lang) {
    //   console.log("存在 :>> ");
    //   if (this.$route.query.lang === "en") {
    //     this.$i18n.locale = "en";
    //     this.$refs.formPageRef.changeLanguage("zh");
    //     window.sessionStorage.setItem("sessionLang", "en");
    //   } else {
    //     this.$i18n.locale = "zh";
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>>00 ", data);
    //     });
    //     window.sessionStorage.setItem("sessionLang", "zh");
    //   }
    // } else {
    //   let lang = window.sessionStorage.getItem("sessionLang") || "zh";
    //   console.log("不存在 :>> -sessionStorage", lang);
    //   if (lang === "zh") {
    //     console.log("进入11111", lang);
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>> 1", data);
    //     });
    //     this.$i18n.locale = "zh";
    //   } else {
    //     console.log("进入22222", lang);
    //     this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
    //       console.log("data :>>2 ", data);
    //     });
    //     this.$i18n.locale = "en";
    //     this.$refs.formPageRef.changeLanguage("zh");
    //   }
    // }
  },
  methods: {
    // changeLanguage(lang) {
    //   console.log("changelang :>> ", lang);
    //   let lang_ = lang === "zh" ? "en" : "zh";
    //   this.$i18n.locale = lang_;
    //   window.sessionStorage.setItem("sessionLang", lang_);
    //   this.$refs.formPageRef.changeLanguage(lang);
    //   if (lang === "zh") {
    //     this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
    //       console.log("data :>> 3", data);
    //     });
    //     // this.$router.push(getLocalePath('/about', 'en'))
    //   } else {
    //     this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
    //       console.log("data :>>4 ", data);
    //     });
    //   }
    // },
    // testFn() {
    //   console.log("this.$i18n.locale :>> ", this.$i18n.locale);
    // },
  },
}
</script>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';

.img {
  object-fit: cover;
}

.contaier {
  .top-nvb_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: #cccccc8c solid 1px;
    z-index: 1000;
    // background-color: #fff;
    backdrop-filter: blur(10px);
    background-color: #fafafab3 !important;

    .top-nvb {
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      // padding: 20px 0;

      .logo-box {
        max-width: 120px;
        // margin: 0 auto;
      }

      .lang {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0%, -50%);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}

.top-banner {
  width: 100%;
  height: 80vh;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
